import { render, staticRenderFns } from "./SensorShow.vue?vue&type=template&id=6674df66&scoped=true"
import script from "./SensorShow.vue?vue&type=script&lang=js"
export * from "./SensorShow.vue?vue&type=script&lang=js"
import style0 from "./SensorShow.vue?vue&type=style&index=0&id=6674df66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6674df66",
  null
  
)

export default component.exports